export default __webpack_public_path__ + "static/tony-217fb0c9d41d18b510cb76405d1ff376.jpg";